<template>
  <div
    id="sidebar"
    class="px-3 py-4"
    :style="
      'background-image: url(' + require('@/assets/images/bg-seigaha.png') + ')'
    "
  >
    <h3 class="h5">総工事費</h3>
    <div class="price-card">
      <div
        class="price-card-header d-flex"
        :class="collapsed ? 'collapsed' : ''"
      >
        <div
          class="
            flex-fill
            text-center
            total-price
            bg-primary
            text-white
            h3
            mb-0
            pt-1
          "
        >
          <small class="mr-1">¥</small>{{ grandTotal.toLocaleString() }}
        </div>
        <b-button
          variant="primary"
          class="gd-btn-append"
          :class="collapsed ? 'collapsed' : ''"
          @click="collapsed = !collapsed"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
          >
            <polyline
              fill="none"
              stroke="#fff"
              stroke-width="2"
              points="0,6 6,11 12,6"
            />
          </svg>
        </b-button>
      </div>
      <b-collapse v-model="collapsed">
        <div class="price-card-body">
          <div class="price-card-section p-2">
            <dl class="form-row no-gutters mb-0">
              <dt class="col-3 text-primary">現在の<br />工事費</dt>
              <dd class="col-9 text-right h3 text-primary pt-1 mb-3">
                <small class="mr-1">¥</small>{{ total.toLocaleString() }}
              </dd>
              <dt class="col-5">取外料金</dt>
              <dd class="col-7 text-right">¥{{ removal.toLocaleString() }}</dd>
              <dt class="col-5">リサイクル料金</dt>
              <dd class="col-7 text-right">
                ¥{{ recycling.toLocaleString() }}
              </dd>
              <dt class="col-5">標準工事費</dt>
              <dd class="col-7 text-right">¥{{ standard.toLocaleString() }}</dd>
              <dt class="col-5">追加工事費</dt>
              <dd class="col-7 text-right">
                ¥{{ additional.toLocaleString() }}
              </dd>
            </dl>
          </div>
          <div
            v-for="(detail, i) in priceDetail"
            :key="i"
            class="price-card-section p-2"
          >
            <dl class="form-row no-gutters mb-0">
              <dt class="col-3 text-primary">{{ i + 1 }}台目の<br />工事費</dt>
              <dd class="col-6 text-right h3 text-primary pt-1">
                <small class="mr-1">¥</small>{{ detail.total.toLocaleString() }}
              </dd>
              <dd class="col-3 text-right">
                <b-button
                  variant="link"
                  size="sm"
                  class="text-danger text-decolation-none"
                  @click="showDeleteModal(i)"
                >
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="22"
                    viewBox="0 0 448 512"
                    class=""
                  >
                    <path
                      fill="currentColor"
                      d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                      class=""
                    ></path>
                  </svg>
                </b-button>
              </dd>
              <dt class="col-5">取外料金</dt>
              <dd class="col-7 text-right">
                ¥{{ detail.removal.toLocaleString() }}
              </dd>
              <dt class="col-5">リサイクル料金</dt>
              <dd class="col-7 text-right">
                ¥{{ detail.recycling.toLocaleString() }}
              </dd>
              <dt class="col-5">標準工事費</dt>
              <dd class="col-7 text-right">
                ¥{{ detail.standard.toLocaleString() }}
              </dd>
              <dt class="col-5">追加工事費</dt>
              <dd class="col-7 text-right">
                ¥{{ detail.additional.toLocaleString() }}
              </dd>
            </dl>
          </div>
        </div>
      </b-collapse>
    </div>
    <!-- /.price-card -->
    <div v-if="key1 !== ''">
      <p
        class="off-text text-left"
        style="
          color: red;
          margin-top: 15px;
          margin-bottom: 5px;
          font-weight: bold;
          font-size: 14px;
        "
      >
        {{ key1 }}
      </p>
      <div class="text-right">
        <small style="width: 100%">※沖縄店を除く</small>
      </div>
    </div>
    <!-- /.price-card -->
    <!-- <div class="p-4" v-if="priceDetail.length && isInServiceArea">
      <b-button
        variant="warning"
        size="lg"
        block
        class="btn-gd tracking-1 font-weight-bold"
        @click="goToPage2()"
        >取付を依頼する</b-button
      >
    </div> -->
    <ul class="font-weight-normal line-height-1_7 mt-5">
      <li>
        各種キャンペーン割引、工事付商品でご注文のお客様は本お申込完了後に改めてご案内致します。
      </li>
      <li>本シミュレーション結果は目安料金（消費税込み）です。</li>
      <li>最終確定の料金は、訪問時にご自宅環境を確認してご連絡します。</li>
      <li>メーカー設置基準に満たない設置は行なえません。</li>
      <li>
        環境、設置内容、機種によって、以下が発生する場合があります。
        <ol>
          <li>別途作業料の発生</li>
          <li>訪問日の調整（別日再訪問）</li>
          <li>設置のお断り</li>
        </ol>
      </li>
      <li>
        賃貸住宅や集合住宅の場合、穴あけやコンセント工事が必要な際に管理会社の許可が必要です。
      </li>
      <li>工事追加料金は、当日クレジットカード・キャッシュレス決済、または後日銀行振込（振込手数料はお客様ご負担）でのお支払いとなります。</li>
      <li>雨天など天候不良の場合は、日程を調整させて頂く場合があります。</li>
    </ul>
    <DeleteModal ref="DeleteModal" />
    <PreGoToPage2Modal ref="PreGoToPage2Modal" />
  </div>
  <!-- /#sidebar -->
</template>

<script>
import { mapState, mapActions } from "vuex";
import DeleteModal from "./modals/DeleteModal";
import PreGoToPage2Modal from "./modals/PreGoToPage2Modal";

export default {
  created() {
    this.read();
  },
  components: {
    DeleteModal,
    PreGoToPage2Modal,
  },
  data() {
    return {
      collapsed: true,
      //データ読込
      key1: "",
    };
  },
  computed: {
    ...mapState({
      total() {
        return this.$store.getters.total;
      },
      removal() {
        return this.$store.getters.removal;
      },
      recycling() {
        return this.$store.getters.recycling;
      },
      standard() {
        return this.$store.getters.standard;
      },
      additional() {
        return this.$store.getters.additional;
      },
      priceDetail() {
        return this.$store.getters.priceDetail;
      },
      grandTotal() {
        return this.$store.getters.grandTotal;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
      isInServiceArea() {
        return this.$store.getters.isInServiceArea;
      },
    }),
  },
  methods: {
    goToPage2() {
      if (this.maxStep < 12) {
        // 見積途中の場合警告出す
        this.$refs.PreGoToPage2Modal.show();
      } else {
        // vuexに保存
        this.doPushPriceDetail();
        this.$router.push({ name: "page2" });
      }
    },
    ...mapActions({
      doPushPriceDetail: "doPushPriceDetail",
    }),
    showDeleteModal(index) {
      this.$refs.DeleteModal.show(index);
    },
    read() {
      const url = "functions/read.php";
      this.axios
        .get(url, null)
        .then((res) => {
          console.log(res.data);
          if (res.data == false || res.data == "" || res.data == "false") {
            console.log(res.data);
          } else {
            let data = JSON.parse(res.data);
            console.log(data.key1);
            console.log(this.key1);
            this.key1 = data.key1;
            console.log(this.key1);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
#sidebar {
  background-repeat: repeat;
  position: sticky;
  height: calc(100vh - 0rem);
  overflow-y: auto;
  top: 0rem;
}
.price-card-header {
  border-radius: 0.25rem 0 0 0.25rem;
  overflow: hidden;
  &.collapsed {
    border-radius: 0.25rem 0 0 0;
  }
}
.price-card-body {
  border: 2px solid #5385b0;
  border-top-width: 0;
  border-radius: 0 0 0.25rem 0.25rem;
  background-color: #fff;
}
.price-card-section + .price-card-section {
  border-top: 2px solid #5385b0;
}
.gd-btn-append {
  background-color: #46749c;
  border-color: #31526e !important;
  &.collapsed {
    svg {
      transform: rotate(180deg);
    }
  }
}
</style>